export default __webpack_public_path__ + "static/media/wsa.617f9b34.jpg";